import Vuex from 'vuex'
import Vue from 'vue'
/**/
/*import inventoryTurnoverRule from './businessRules/inventoryTurnoverRule/index.js'*/

Vue.use(Vuex)
const state={
  userInformation:{
    company:'',
    realname:'',
    role:'',
    avatar:'',
    token:'',
    client_key:'',
    username:'',
    version:0,
    privilege:[],
  },
  zCount:16,
  projectsId:'0',
  companyId:'0',
  lampEdit:true,
  loadingGetMap:false,
  record:'',
  linkTo:'/home',
  homeData:{},
}
const getters={
  company:state=>state.userInformation.company,
  realname:state=>state.userInformation.realname,
  role:state=>state.userInformation.role,
  avatar:state=>state.userInformation.avatar,
  token:state=>state.userInformation.token,
  client_key:state=>state.userInformation.client_key,
  username:state=>state.userInformation.username,
  version:state=>state.userInformation.version,
  privilege:state=>state.userInformation.privilege,

  projectsId:state=>state.projectsId,
  companyId:state=>state.companyId,
  lampEdit:state=>state.lampEdit,
  loadingGetMap:state=>state.loadingGetMap,
  record:state=>state.record,
  linkTo:state=>state.linkTo,
  zCount:state=>state.zCount,

  homeData:state=>state.homeData,
}
const actions={
   
}
const mutations={
  setHomeData:(state,payload)=>{
    state.homeData = payload.homeData;
  },
  
  routerLink:(state,payload)=>{
    state.linkTo = payload.linkTo;
  },
  setProjectsId:(state,payload)=>{
    state.projectsId = payload.projectsId;
    state.companyId = payload.companyId;
  },
  setLampEdit:(state,payload)=>{
    state.lampEdit = payload.lampEdit;
  },
  setLoadingGetMap:(state,payload)=>{
    state.loadingGetMap = payload.loadingGetMap;
  },
  setRecord:(state,payload)=>{
    state.record = payload.record;
  },
  setUserInformation:(state,payload)=> {
    state.userInformation.company = payload.company;
    state.userInformation.realname = payload.realname;
    state.userInformation.role = payload.role;
    state.userInformation.avatar = payload.avatar;
    state.userInformation.token = payload.token;
    state.userInformation.client_key = payload.client_key;
    state.userInformation.username = payload.username;
    state.userInformation.version = payload.version;
    state.userInformation.privilege = payload.privilege;
  }
}
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  // modules: {
    /*业务规则*/
    // inventoryTurnoverRule,
  // }
})


// WEBPACK FOOTER //
// ./src/store/index.js